import './File.scss'

import Menu, { MenuItem } from '../Menu/Menu'
import React, { useCallback, useMemo } from 'react'

import { ReactComponent as CompressedIcon } from '../../icons/files/compressed.svg'
import { ReactComponent as DocumentIcon } from '../../icons/files/document.svg'
import Dropdown from '../Dropdown/Dropdown'
import { ReactComponent as ImageIcon } from '../../icons/files/image.svg'
import { ReactComponent as PDFIcon } from '../../icons/files/pdf.svg'
import { downloadFile } from '../../helpers/download'
import t from '../../helpers/i18n'

const File = ({ file, includeRemove, onRemove }) => {

  const handleRemove = useCallback(() => {
    if (onRemove) onRemove(file)
  }, [onRemove, file])

  const handleDownload = useCallback(() => {
    downloadFile({ source: file.source })
  }, [file])

  return (
    <Dropdown button={<FileButton file={file}/>} basic>
      <Menu size="medium" >
        {file && file.source && <MenuItem title={t('labels.Download')} icon="DownloadArrow" onClick={handleDownload} />}
        {includeRemove && <MenuItem title={t('Remove')} icon="DeleteIcon" onClick={handleRemove} />}
      </Menu>
    </Dropdown>
  )
}

const FileButton = ({ file }) => {
  const size = useMemo(() => file.size && file.size > 0 && formatSize(file.size), [file])

  return (
    <div className="file" tabIndex="0">
      {typeIcon(file.type)}
      <div className="-name label-small-basic">{file.name}</div>
      {size && size > 0 && <div className="-size label-small-basic">{size}</div>}
    </div>
  )
}

const typeIcon = (type) => {
  if (!type) return <DocumentIcon />
  if ("application/pdf" === type) return <PDFIcon />
  if (type.match(/image/)) return <ImageIcon />
  if (type.match(/\/.*(zip|rar|compressed|octect)/)) return <CompressedIcon />
  return <DocumentIcon />
}

const MAGNITUDES = ['B', 'Kb', 'Mb', 'Gb']
const formatSize = (size) => {
  let magnitude = 0
  while (size >= 1024.0) {
    size = size / 1024.0
    magnitude += 1
  }
  return (magnitude === 0) ? size + MAGNITUDES[magnitude] : size.toFixed(1) + MAGNITUDES[magnitude]
}

export default File